import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'slots'
})
export class SlotsPipe implements PipeTransform {

transform(value: string, data: any): string {
  if (!value) return '';

  // Split the range into start and end
  const [start, end] = value.indexOf(' - ') !== -1 ?  value.split(' - ') : value.split('-');

  // Helper function to remove seconds
  const formatTime = (time: string) => {
    const parts = (time || '').trim().split(':');
    const isPM = (parts?.[2] || '').indexOf("PM") !== -1;
    return `${parts[0]}:${parts[1]} ${isPM ? (data.lang === 'en' ? 'PM' : 'م') : (data.lang === 'en' ? 'AM' : 'ص')}`;
    // data.lang
  };

  return `${formatTime(start)} - ${formatTime(end)}`;
}


}
